var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushSize1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61003 4.61142C4.28953 4.97111 4.01034 5.4215 3.81368 5.84401C3.34755 6.84541 2.15789 7.27934 1.15649 6.81322C0.155089 6.3471 -0.278841 5.15744 0.187281 4.15604C0.517496 3.44661 0.99852 2.65188 1.62359 1.95037C2.23798 1.26086 3.09366 0.547921 4.19286 0.204561C5.36965 -0.163037 6.65051 -0.048694 7.87362 0.657421C9.02638 1.32293 10.0345 2.45593 10.9424 3.97298C11.6698 5.18841 12.2369 5.70197 12.5609 5.89703C12.7084 5.98579 12.7861 5.99733 12.8013 5.99917C12.8135 6.00066 12.825 6.00143 12.8546 5.99142C12.9445 5.96109 13.1646 5.83555 13.4549 5.47172C13.7323 5.12411 13.9743 4.6814 14.1429 4.25889C14.5522 3.23296 15.7157 2.7331 16.7416 3.14242C17.7675 3.55173 18.2674 4.71523 17.8581 5.74116C17.575 6.45058 17.1509 7.253 16.5815 7.96659C16.0251 8.66395 15.2177 9.41566 14.1334 9.7815C12.9555 10.1789 11.6865 10.0394 10.4981 9.32407C9.38825 8.65603 8.40855 7.52829 7.51013 6.02707C6.79222 4.82747 6.21598 4.31917 5.87371 4.12158C5.60179 3.96459 5.47701 3.99404 5.38552 4.02262C5.21643 4.07544 4.94121 4.23975 4.61003 4.61142Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushSize1);
export default __webpack_public_path__ + "static/media/brush_size1.03b4142e5591d07a90745636007e75dc.svg";
export { ForwardRef as ReactComponent };